import { render, staticRenderFns } from "./PeakGraph.vue?vue&type=template&id=22165fc4"
import script from "./PeakGraph.js?vue&type=script&lang=js&external"
export * from "./PeakGraph.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports